<script setup>
// Marka guvenligi sekmesi.
//
// MCP sunucusunda marka guvenligi (engel listeleri, yayinci listeleri, icerik
// tipi filtreleri) icin arac YOK. Bos bir tablo ya da ornek veri gostermek
// kullaniciyi yanlis yonlendirir - ayar degistirdigini sanir, oysa hicbir sey
// kaydedilmez. Bu yuzden sekme durumu acikca anlatiyor ve isi yapabilecegi
// yere yonlendiriyor.
import { useI18n } from 'vue-i18n';

defineProps({
  hesap: { type: String, default: '' },
  hesapAyrinti: { type: Object, default: null },
});

const { t } = useI18n();

// Meta'nin marka guvenligi denetimleri hesap duzeyinde Ads Manager'da tutulur.
const ADS_MANAGER_ADRESI = 'https://adsmanager.facebook.com/';
</script>

<template>
  <div class="p-6">
    <section class="max-w-2xl border rounded-lg border-n-weak">
      <header class="px-4 py-3 border-b border-n-weak">
        <h2 class="text-sm font-medium text-n-slate-12">
          {{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.BASLIK') }}
        </h2>
      </header>

      <div class="flex flex-col gap-3 px-4 py-5">
        <p class="text-sm text-n-slate-12">
          {{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.ARAC_YOK') }}
        </p>
        <p class="text-sm text-n-slate-11">
          {{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.NEREDEN') }}
        </p>

        <ul class="pl-5 text-sm list-disc text-n-slate-11">
          <li>{{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.MADDE_ENGEL_LISTESI') }}</li>
          <li>{{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.MADDE_YAYINCI') }}</li>
          <li>{{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.MADDE_ICERIK') }}</li>
        </ul>

        <a
          :href="ADS_MANAGER_ADRESI"
          target="_blank"
          rel="noopener noreferrer"
          class="text-sm text-n-brand hover:underline"
        >
          {{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.ADS_MANAGER_AC') }}
        </a>

        <p class="text-xs text-n-slate-11">
          {{ t('META_ADS.AYARLAR.MARKA_GUVENLIGI.NOT') }}
        </p>
      </div>
    </section>
  </div>
</template>
